import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import InputBase from '@material-ui/core/InputBase';
import Typography from '@material-ui/core/Typography';
import { createMuiTheme } from '@material-ui/core/styles';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import LockIcon from '@material-ui/icons/Lock';
import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';
import { ThemeProvider } from '@material-ui/styles';
import CircularProgress from "@material-ui/core/CircularProgress";
import css from './login.css';
import ReckonLogo from './logo-icon.png';


const theme = createMuiTheme({
  palette: {
    primary: { main: "#262626" },
    secondary: { main: "#00bd9d" }
  },
  overrides: {
    MuiButton: {
      containedPrimary: {
        fontWeight: "bold"
      },
      containedSecondary: {
        color: "white",
        fontWeight: "bold"
      }
    }
  }
});

const renderTextField = ({
  input,
  label,
  id,
  meta: { touched, error },
  ...custom
}) => (
  <div className={css.pb10}>
    {id === "email" ? (
      <MailOutlineIcon className={css.icon} />
    ) : id === "password" ? (
      <LockOpenIcon className={css.icon} />
    ) : (
      <LockIcon className={css.icon} />
    )}
    <TextField
      style={{ width: "80%" }}
      placeholder={label}
      {...input}
      {...custom}
    />
    <div className={css.error}>{touched && error}</div>
  </div>
);

let SetPasswordForm = props => {
  const { handleSubmit, pristine, submitting, xpa, username, submit } = props;
  let buttonInfo = 'Set password';

  if (xpa.setting) buttonInfo = <CircularProgress size={24} />;
  if (xpa.setting === false) buttonInfo = 'Error, try again!';
  
  return (
    <React.Fragment>
      <ThemeProvider theme={theme}>
        <Container className={css.background} component="main" maxWidth="xs">
          <CssBaseline />
          <div className={css.paper}>
            <img src={ReckonLogo} className={css.avatar} />
            <Typography component="h1" variant="h5">
              Let's set a new password
            </Typography>
            <form className={css.form} onSubmit={handleSubmit(submit)}>
              <div>
                <div className={css.pb10}>
                  <MailOutlineIcon className={css.upperIcon} />
                  <InputBase
                    name="username"
                    defaultValue={username}
                    disabled={true}
                    style={{ color: '#262626', width: "80%" }}
                  />
                </div>
                <Field
                  component={renderTextField}
                  margin="normal"
                  id="password"
                  autoFocus
                  fullWidth
                  name="password"
                  label="Password"
                  type="password"
                />
                <Field
                  component={renderTextField}
                  margin="normal"
                  id="confirmPassword"
                  fullWidth
                  name="confirmPassword"
                  label="Confirm Password"
                  type="password"
                />
              </div>
              <div className={css.pl35}>
                <div className={[css.pr30, css.pt20, css.mb24].join(" ")}>
                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    color="secondary"
                    disabled={pristine || submitting}>
                    {buttonInfo}
                  </Button>
                </div>
              </div>
            </form>
          </div>
        </Container>
      </ThemeProvider>
    </React.Fragment>
  );
};

function mapStateToProps(state) {
  const { xpa } = state;
  return { xpa };
}

SetPasswordForm = connect(mapStateToProps)(
  reduxForm({
    form: "setPasswordForm"
  })(SetPasswordForm)
);

export default SetPasswordForm;



// WEBPACK FOOTER //
// ./src/components/Portal/SetPasswordForm.js